module.exports = __webpack_public_path__ + "static/media/29DUNON13.1611d108.jpg";